import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const MentionsLegales = () => {
  return (
    <Layout>
      <SEOHead
        title="Mentions légales - JIIA Studio"
        description="Mentions légales du site JIIA Studio, architecte d'intérieur à Lyon et Ouest Lyonnais."
        canonical="/mentions-legales"
      />

      <section className="py-24 md:py-32">
        <div className="container max-w-3xl">
          <h1 className="font-heading text-4xl md:text-5xl font-light mb-12">Mentions légales</h1>

          <div className="space-y-8 font-body text-muted-foreground leading-relaxed text-sm">
            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Éditeur du site</h2>
              <p>
                <strong className="text-foreground">JIIA STUDIO</strong><br />
                Société par actions simplifiée unipersonnelle (SASU)<br />
                Capital social : 1 000,00 €<br />
                Siège social : 3 rue des Forges, 69290 Grézieu-la-Varenne<br />
                SIRET : 937 972 057 00015<br />
                RCS Lyon : 937 972 057<br />
                N° TVA intracommunautaire : FR18937972057
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Directrice de la publication</h2>
              <p>Charline Jacob, Présidente de JIIA Studio SASU.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Hébergement</h2>
              <p>
                Ce site est hébergé par :<br />
                <strong className="text-foreground">Lovable (GPT Engineer Inc.)</strong><br />
                San Francisco, Californie, États-Unis<br />
                Site web : <a href="https://lovable.dev" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">lovable.dev</a>
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Activité</h2>
              <p>
                JIIA Studio exerce une activité d'architecture d'intérieur et de création de visuels 3D photoréalistes.<br />
                Code APE : 74.10Z - Activités spécialisées de design.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, photographies, illustrations, visuels 3D, logos, icônes) 
                est la propriété exclusive de JIIA Studio ou de ses partenaires et est protégé par les lois françaises et 
                internationales relatives à la propriété intellectuelle.
              </p>
              <p className="mt-2">
                Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments 
                du site, quel que soit le moyen ou le procédé utilisé, est interdite sauf autorisation écrite préalable de JIIA Studio.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Responsabilité</h2>
              <p>
                JIIA Studio s'efforce d'assurer l'exactitude des informations diffusées sur ce site mais ne saurait être 
                tenue responsable d'éventuelles erreurs, omissions ou des résultats obtenus par l'utilisation de ces informations. 
                JIIA Studio se réserve le droit de modifier le contenu du site à tout moment et sans préavis.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Liens hypertextes</h2>
              <p>
                Ce site peut contenir des liens vers d'autres sites. JIIA Studio n'exerce aucun contrôle sur ces sites 
                et décline toute responsabilité quant à leur contenu.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Données personnelles</h2>
              <p>
                Pour en savoir plus sur la collecte et le traitement de vos données personnelles, 
                consultez notre <a href="/politique-de-confidentialite" className="text-accent hover:underline">politique de confidentialité</a>.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Cookies</h2>
              <p>
                Ce site utilise des cookies. Un bandeau de consentement vous permet d'accepter ou de refuser 
                les cookies non essentiels lors de votre première visite. Pour plus de détails, consultez 
                notre <a href="/politique-de-confidentialite" className="text-accent hover:underline">politique de confidentialité</a>.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">Droit applicable</h2>
              <p>
                Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux 
                compétents de Lyon seront seuls compétents.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default MentionsLegales;